module.exports = __webpack_public_path__ + "static/media/filter-filled-tool-symbol.c9ccfad1.svg";